import { createContext } from 'react';

export const SelectionPlanContext = createContext();
